import React, { FC } from "react";

interface RulesContentProps {
  setOpen: () => void;
}

const RulesContent: FC<RulesContentProps> = ({ setOpen }) => {
  setTimeout(() => {
    const rulesDialog = document.getElementById("dialog");
    rulesDialog?.scroll(0, 0);
  });

  return (
    <div id="rules-modal">
      <div className="absolute left-[50%] ml-[-41px] top-[-20px]">
        <img src="./static/moroz.png" alt="Дед Мороз" />
      </div>
      <div className="w-[990px] h-[1352px] bg-white pt-[73px] pl-[206px] pr-[206px]">
        <div className="flex flex-col items-center">
          <p className="main-title text-[36px] font-medium font-bold">
            Как стать
          </p>
          <p className="main-title text-[36px] font-medium font-bold">
            Дедом Морозом?
          </p>
        </div>
        <div className="pt-[44px]">
          <p className="text-[18px] pb-[44px]">
            <pre>
              <b>1. Как принять участие?</b>
            </pre>
             Вы можете изучить все карточки и выбрать одно или несколько писем, которые вам больше всего откликаются. Чтобы закрепить подарок за собой, нужно нажать кнопку «Сделать подарок».
          </p>
          <p className="text-[18px] pb-[44px]">
            <pre>
              <b>2. Что делать после выбора подарка?</b>
            </pre>
              Подготовьте и передайте подарок в нижегородский офис. Подарок должен быть красиво упакован и подписан.
              Если вы находитесь в другом городе, то оформляйте заказ на маркетплейсе с доставкой в офис (адрес: Нижний Новгород, ул. Алексеевская, 6/16), а мы поможем с упаковкой подарков. По всем вопросам обращайтесь в HR-отдел к Арине Усовой.
          </p>
          <p className="text-[18px] pb-[44px] pt-[44px]">
            <pre>
              <b>Когда приносить подарок?</b>
            </pre>
              Собираем подарки в офисе до <span style={{ color: "#3F44D9" }}>22 декабря.</span> К ребятам они уедут 24-26 декабря.
          </p>
          <div className="flex flex-col items-center">
            <button
              onClick={setOpen}
              type="button"
              className="mt-8 inline-block rounded-full px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal transition duration-150 ease-in-out bg-[#3F44D9] w-[199px] h-[56px] text-[16px]"
            >
              ЯСНО-ПОНЯТНО 👌
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RulesContent;
